// extracted by mini-css-extract-plugin
module.exports = {"background":"content-module--background--3FdQb","appWrapper":"content-module--appWrapper--25-6B","backgroundCoin":"content-module--backgroundCoin--3t7hn"};